<template>
  <footer class="g-ft">
    <div class="m-name">
      粤ICP备13027716号 版权所有：广州昊达信息科技有限公司 联系电话：400-138-6626 <br>
      公司地址：广州大道中富力新天地中心4206室
    </div>
  </footer>
</template>
<script>
export default {
 name:"footBar",
  components: {

  },
  props: {
    
  },
  data () {
    return {

    }
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/z-0.6.less";
@import "../../assets/css/variables.less";
.g-ft{
  height: 120px;
  background: @mainDarkColor;
  .m-name{
    .tc();
    padding: 39px 0;
    font-size:12px;
    line-height: 1.8;
    color: #7a7a7a;
  }
  
}
@media (max-width: 992px) {
    .g-ft{
      height: 90px;
      .m-name{
        padding: 18px 10px;
        line-height: 18px;
      }
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/footbar/index.vue